import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "styled-components";
import theme from "./theme";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import { queryClient } from "./queryClient";
import ErrorBoundary from "./pages/ErrorBoundary";
import { MandateStatusProvider } from "./context/MandateStatusContext";
import { AxiosInterceptor } from "./data/axios";
import { BrowserRouter } from "react-router-dom";
import { ProfileStatusProvider } from "./context/ProfileStatusContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <AxiosInterceptor>
            <MandateStatusProvider>
              <ProfileStatusProvider>
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>

                <ToastContainer />
              </ProfileStatusProvider>
            </MandateStatusProvider>
          </AxiosInterceptor>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
